<template>
  <div class="content-card consultation-data terms-and-notes">
    <slot name="headlineConsultationConsent"></slot>
    <div class="input-info-exchange-consent">
      <b-form-checkbox :class="['mt-0']"
        v-model="selectedInfoExchangeConsent"
        id="consentexchange"
      >
      <div class="agb-information-article-label">
        <span class="docM" v-html="dataHandlingTerms"></span>
      </div>
      </b-form-checkbox>
    </div>
    <div class="input-contact-consent">
      <b-form-group class="checkbox-group mt-2">
        <b-form-checkbox :class="['mt-0']"
               id="consentcontact"
               v-model="selectedContactConsent"
               class="agb-information-article-checkbox">
            <span class="docM" v-html="bewCheckoutTerms"></span>
        </b-form-checkbox>
      </b-form-group>
    </div>
  </div>
</template>
<script>
import syncProperty from '@/mixins/syncProperty'

export default {
  name: 'ConsultationConsent',
  props: {
    consents: {
      type: Array
    }
  },
  mixins: [
    syncProperty('selectedInfoExchangeConsentProp', 'selectedInfoExchangeConsent'),
    syncProperty('selectedContactConsentProp', 'selectedContactConsent')
  ],
  mounted () {
    window.simonSummaryAGBContractSummary = () => {
      const baseUrl = this.$config.apiUrl
      if (this.contractDocumentUrl) {
        this.isAgreement = true
        if (typeof window.openNewWindowUrlInApp === 'function') {
          window.openNewWindowUrlInApp(`${baseUrl}${this.contractDocumentUrl}`)
        } else {
          window.open(`${baseUrl}${this.contractDocumentUrl}`)
        }
        // tracking
        if (typeof window.trackingNS?.track?.tracking === 'function' && typeof window.trackingNS?.track?.getFileNameByUrl === 'function') {
          const data = {
            file_name: window.trackingNS.track.getFileNameByUrl(this.contractDocumentUrl)
          }
          window.trackingNS.track.tracking('download file', data)
        }
      }
    }
  },
  computed: {
    dataHandlingTerms: function () {
      const t = this.consents_.find(item => item.name === 'data_handling_terms')?.text || ''
      return this.addClickHandlerForModals('data_handling_terms', t)
    },
    bewCheckoutTerms: function () {
      const t = this.consents_.find(item => item.name === 'bew_checkout_terms')?.text || ''
      return this.addClickHandlerForModals('bew_checkout_terms', t)
    },
    consents_: function () {
      return Array.isArray(this.consents) ? this.consents : []
    },
    isIosDevice () {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }
  },
  methods: {
    addClickHandlerForModals (terms, t) {
      t = t.replaceAll('<a class="contract_data_info_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'contract_data_info_modal\')">')
      t = t.replaceAll('<a class="company_info_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'company_info_modal\')">')
      t = t.replaceAll('<a class="usage_data_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'usage_data_modal\')">')
      t = t.replaceAll('<a class="product_info_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'product_info_modal\')">')
      t = t.replaceAll('<a class="contract_info_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'contract_info_modal\')">')
      t = t.replaceAll('<a class="datatraffic_info_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'datatraffic_info_modal\')">')
      t = t.replaceAll(/"http:\/\/[^/]+\//g, '"/')
      t = t.replaceAll(/"https:\/\/[^/]+\//g, '"/')
      t = t.replaceAll(/"\/\/[^/]+\//g, '"/')
      t = t.replaceAll('<p> </p>', '')
      t = t.replaceAll('"/datenschutz"', '"/datenschutz" target="_blank"')
      return t
    }
  }
}
</script>
